import {
	Eyebox,
	InputStyled,
	StyledInput,
	StyledSelect,
	StyledSpan,
	logo,
} from "./Input.styles";
import { ReactSVG } from "react-svg";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { format } from "rut.js";

const Input = ({
	name,
	type,
	label,
	placeholder,
	required,
	onChange,
	error,
	defValue,
	isRut,
}) => {
	const [value, setValue] = useState("");
	const [inputType, setInputType] = useState(type);
	const [showPass, setShowPass] = useState(false);
	const [selectedId, setSelectedId] = useState(false);

	useEffect(() => {
		if (type === "phone") {
			let newValue = {
				input: name,
				type: type,
				required: required,
				value: `+${value}`,
			};
			onChange(newValue);
		} else if (type === "id") {
			let newValue = {
				input: name,
				type: type,
				required: required,
				value: `${value}`,
			};
			onChange(newValue);
		} else {
			let newValue = {
				input: name,
				type: type,
				required: required,
				value: value,
			};
			onChange(newValue);
		}
	}, [value]);

	const handleChange = (evt) => {
		if (isRut) {
			//Remove -
			let newValue = evt.target.value.replace("-", "");
			const value = format(newValue, { dots: false });
			return setValue(value);
		}

		setValue(evt.target.value);
	};

	const handleSelectChange = (evt) => {
		setSelectedId(evt.target.value);
	};

	const passConditional =
		type === "password-default" ||
		type === "password-confirm" ||
		type === "password-confirm-strong" ||
		type === "password-weak" ||
		type === "password-strong";

	return (
		<StyledInput>
			<label>{label}</label>

			<InputStyled
				error={error}
				name={name}
				type={inputType}
				placeholder={placeholder}
				value={value || defValue}
				onChange={handleChange}
				maxLength={type === "rut" ? 10 : type === "phone" ? 14 : type === "id" ? 11 : 80}
				className={`${
					passConditional
						? showPass
							? ""
							: "show-password-font"
						: ""
				}`}
			/>
			{/* {type === "id" && (
				<StyledSelect onChange={handleSelectChange}>
					<option value="dni">DNI</option>
					<option value="rut">RUT</option>
				</StyledSelect>
			)} */}
			{type === "id-rut" && (
				<StyledSelect onChange={handleSelectChange}>
					<option value="rut">RUT</option>
				</StyledSelect>
			)}
			{type === "id-dni" && (
				<StyledSelect onChange={handleSelectChange}>
					<option value="DNI">DNI</option>
				</StyledSelect>
			)}

			{type === "phone" && <StyledSpan>+</StyledSpan>}
			{passConditional && (
				<Eyebox onClick={() => setShowPass(!showPass)}>
					<ReactSVG
						src={logo}
						className={`${
							!showPass ? "" : "closed-eye-stripe-show"
						}`}
					/>
				</Eyebox>
			)}
		</StyledInput>
	);
};

Input.defaultProps = {
	type: "text",
};

Input.propTypes = {
	name: PropTypes.string,
	label: PropTypes.string,
	placeholder: PropTypes.string,
	type: PropTypes.string.isRequired,
	required: PropTypes.bool,
	show: PropTypes.bool,
	onChange: PropTypes.func,
};

export default Input;
